module.exports = __webpack_public_path__ + "static/assets/1a82cd502b1a6733b5167c5a57df6b9e.png";